import type { PropsWithChildren, Ref } from 'react';
import { forwardRef } from 'react';

import { TooltipPrimitive } from '@trello/nachos/tooltip';

import styles from './CollaboratorsBadgeCustomTooltip.less';

export const CollaboratorsBadgeCustomTooltip = forwardRef(
  (props: PropsWithChildren<unknown>, ref: Ref<HTMLDivElement>) => {
    const { children, ...rest } = props;
    return (
      <TooltipPrimitive
        placement="bottom"
        {...rest}
        ref={ref}
        className={styles.tooltipContainer}
      >
        {children}
      </TooltipPrimitive>
    );
  },
);
